import React from 'react';

import { Svg, Path } from './HeaderTooth.style';
import { useTheme } from 'ThemeContext';

const HeaderTooth = () => {
  const theme = useTheme();

  return (
    <Svg>
      <defs>
        <pattern
          id='toothing'
          width='19'
          height='20'
          theme={theme.header.toothing}
          patternUnits='userSpaceOnUse'
        >
          <Path d={theme.header.toothing.shape} theme={theme.header.wrapper} />
        </pattern>
      </defs>
      <rect width='100%' height='100%' fill='url(#toothing)' />
    </Svg>
  );
};

export default HeaderTooth;
